export class FreeBooking {
  public bookingMasterHashId: string;
  public bookingCustomFee:string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/freebookingmodel.ts